import { createContext, type JSX, useContext } from 'solid-js'
import { MainModule } from '../../../features/main-module'
import { type GetMRRInteractor } from '../../../features/revenue/domain/interactors/get-mrr.interactor'
import { type GetCashFlowInteractor } from '../../../features/revenue/domain/interactors/get-cash-flow.interactor'
import { type GetChurnInteractor } from '../../../features/revenue/domain/interactors/get-churn.interactor'
import { type GetSubscriberIntervalsInteractor } from '../../../features/revenue/domain/interactors/get-subscriber-intervals.interactor'

interface RevenueContextType {
  getMRR: GetMRRInteractor
  getCashFlow: GetCashFlowInteractor
  getChurn: GetChurnInteractor
  getSubscriberIntervals: GetSubscriberIntervalsInteractor
}

const CorisRevenueContext = createContext<RevenueContextType>()

export const CorisRevenueProvider = (props: { children: JSX.Element }): JSX.Element => {
  const revenueComponent = MainModule.getRevenueComponent()

  const defaultContextValue: RevenueContextType = {
    getMRR: revenueComponent.provideGetMRR(),
    getCashFlow: revenueComponent.provideGetCashFlow(),
    getChurn: revenueComponent.provideGetChurn(),
    getSubscriberIntervals: revenueComponent.provideGetSubscriberIntervals()
  }

  return <CorisRevenueContext.Provider value={defaultContextValue}>{props.children}</CorisRevenueContext.Provider>
}

export const useCorisRevenue = (): RevenueContextType => {
  const context = useContext(CorisRevenueContext)
  if (!context) {
    throw new Error('useCorisRevenue must be used inside a CorisRevenueProvider')
  }
  return context
}
